import {
  WIRE_CONFIGURATOR_OPTIONS_FAIL,
  WIRE_CONFIGURATOR_OPTIONS_REQUEST,
  WIRE_CONFIGURATOR_OPTIONS_RESET,
  WIRE_CONFIGURATOR_OPTIONS_SUCCESS,
  WIRE_CONFIGURATOR_RESOLVE_FAIL,
  WIRE_CONFIGURATOR_RESOLVE_REQUEST,
  WIRE_CONFIGURATOR_RESOLVE_SUCCESS
} from '@/constants/wireConfiguratorConstants'

const EMPTY_AVAILABLE = { category: [], size: [], insulation: [], color: [] }

const initialOptionsState = {
  loading: false,
  available: EMPTY_AVAILABLE,
  activeFilters: {},
  error: null
}

export const wireConfiguratorOptionsReducer = (state = initialOptionsState, action) => {
  switch (action.type) {
    case WIRE_CONFIGURATOR_OPTIONS_REQUEST:
      return { ...state, loading: true, error: null }
    case WIRE_CONFIGURATOR_OPTIONS_SUCCESS:
      return {
        loading: false,
        available: { ...EMPTY_AVAILABLE, ...(action.payload?.available || {}) },
        activeFilters: action.payload?.active_filters || {},
        error: null
      }
    case WIRE_CONFIGURATOR_OPTIONS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case WIRE_CONFIGURATOR_OPTIONS_RESET:
      return initialOptionsState
    default:
      return state
  }
}

const initialResolveState = { loading: false, error: null, lastPids: [] }

export const wireConfiguratorResolveReducer = (state = initialResolveState, action) => {
  switch (action.type) {
    case WIRE_CONFIGURATOR_RESOLVE_REQUEST:
      return { ...state, loading: true, error: null }
    case WIRE_CONFIGURATOR_RESOLVE_SUCCESS:
      return { loading: false, error: null, lastPids: action.payload || [] }
    case WIRE_CONFIGURATOR_RESOLVE_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}
